import createIcon from '../../createIcon';

/**
 * @component @name Login
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgN0w5LjYgOC40TDEyLjIgMTFIMlYxM0gxMi4yTDkuNiAxNS42TDExIDE3TDE2IDEyTDExIDdaTTIwIDE5SDEyVjIxSDIwQzIxLjEgMjEgMjIgMjAuMSAyMiAxOVY1QzIyIDMuOSAyMS4xIDMgMjAgM0gxMlY1SDIwVjE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Login = createIcon('Login', [
  [
    'path',
    {
      d: 'M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z',
      key: 'g5m4v',
    },
  ],
]);

export default Login;
